import React from 'react';
import s from './Divider.module.scss';
import { usewpdataSelectors } from 'lib/wpdataState/selectors';

type DividerTypes = {
  text?: string;
  addMargin?: boolean;
  noText?: boolean;
};
const Divider = ({ text, addMargin, noText }: DividerTypes) => {
  const { hero } = usewpdataSelectors();

  return noText ? (
    <div className={s.lineDivider} style={{ marginBottom: addMargin ? '12px' : '0px' }}>
      <div></div>
    </div>
  ) : (
    <div className={s.divider} style={{ marginBottom: addMargin ? '12px' : '0px' }}>
      <div></div>
      <p style={{ color: hero.styles.dividerTextColor }}>{text}</p>
      <div></div>
    </div>
  );
};

export default Divider;
